module.exports = __webpack_public_path__ + "static/media/icon-any-file.aedb3ae0.svg";